// analyticsMocks.ts
// Données statiques complexes pour simuler l'activité de la plateforme

// ── 1. Vue d'ensemble (Trafic) ────────────────────────────────────
export const mockTrafficOverTime = [
  { date: "01/09", visites: 12500, uniques: 8500, rebond: 35 },
  { date: "08/09", visites: 18400, uniques: 12500, rebond: 32 },
  { date: "15/09", visites: 26800, uniques: 19400, rebond: 28 },
  { date: "22/09", visites: 42500, uniques: 31100, rebond: 25 },
  { date: "29/09", visites: 68000, uniques: 48500, rebond: 22 },
  { date: "06/10", visites: 112000, uniques: 85400, rebond: 18 },
  { date: "13/10", visites: 185000, uniques: 142900, rebond: 15 },
];

export const mockVisitorSources = [
  { name: "Recherche Organique", value: 4500, fill: "#3b82f6" },
  { name: "Réseaux Sociaux", value: 3100, fill: "#ec4899" },
  { name: "Trafic Direct", value: 1800, fill: "#f59e0b" },
  { name: "Sites Référents", value: 600, fill: "#10b981" },
];

export const mockPeakHours = [
  { hour: "00h-04h", volume: 15 },
  { hour: "04h-08h", volume: 25 },
  { hour: "08h-12h", volume: 85 },
  { hour: "12h-16h", volume: 75 },
  { hour: "16h-20h", volume: 100 },
  { hour: "20h-00h", volume: 90 },
];

// ── 2. Contenu & Pages ────────────────────────────────────────────
export const mockTopPages = [
  { url: "/", title: "Accueil", visites: 145000, tempsMoyen: "2m 45s", sortie: "18%" },
  { url: "/dashboard", title: "Tableau de Bord Citoyen", visites: 82000, tempsMoyen: "5m 10s", sortie: "12%" },
  { url: "/ressources", title: "Ressources & Guides", visites: 56000, tempsMoyen: "3m 50s", sortie: "25%" },
  { url: "/quiz", title: "Boussole Politique (Quiz)", visites: 248000, tempsMoyen: "8m 05s", sortie: "5%" },
  { url: "/alertes", title: "Espace Signalements & Alertes", visites: 39000, tempsMoyen: "2m 50s", sortie: "28%" },
];

// ── 3. Entités (Partis, Candidats, Régions) ───────────────────────
export const mockPopularParties = [
  { id: "RNI", name: "Rassemblement National des Indépendants", vues: 95000, messages: 12000, likes: 42000, temps: "4m 30s" },
  { id: "PAM", name: "Parti Authenticité et Modernité", vues: 81000, messages: 9800, likes: 38000, temps: "3m 15s" },
  { id: "PI", name: "Parti de l'Istiqlal", vues: 62000, messages: 7500, likes: 29000, temps: "2m 50s" },
  { id: "USFP", name: "Union Socialiste des Forces Populaires", vues: 54000, messages: 6200, likes: 24000, temps: "2m 45s" },
  { id: "PJD", name: "Parti de la Justice et du Développement", vues: 49000, messages: 8100, likes: 31000, temps: "3m 40s" },
];

export const mockPopularRegions = [
  { region: "Casablanca-Settat", recherches: 14500, clicDetails: 6800 },
  { region: "Rabat-Salé-Kénitra", recherches: 9200, clicDetails: 4100 },
  { region: "Marrakech-Safi", recherches: 7800, clicDetails: 3400 },
  { region: "Fès-Meknès", recherches: 6500, clicDetails: 2900 },
  { region: "Tanger-Tétouan-Al Hoceïma", recherches: 6100, clicDetails: 2700 },
];

export const mockPopularCandidates = [
  { nom: "Fatima Zahra Mansouri", parti: "PAM", region: "Marrakech-Safi", vues: 2450, contacts: 145 },
  { nom: "Nizar Baraka", parti: "PI", region: "Rabat-Salé-Kénitra", vues: 1980, contacts: 92 },
  { nom: "Aziz Akhannouch", parti: "RNI", region: "Souss-Massa", vues: 1950, contacts: 85 },
  { nom: "Abdelilah Benkirane", parti: "PJD", region: "Rabat-Salé-Kénitra", vues: 1820, contacts: 110 },
  { nom: "Nabila Mounib", parti: "PSU", region: "Casablanca-Settat", vues: 1650, contacts: 130 },
];

export const mockPopularEmissions = [
  { titre: "Le Débat", chaine: "2M", vues: 15400, likes: 3200, partages: 1100 },
  { titre: "L'Heure de Vérité", chaine: "Al Aoula", vues: 12100, likes: 2800, partages: 850 },
  { titre: "Face à Face", chaine: "Hit Radio", vues: 9800, likes: 2100, partages: 600 },
  { titre: "Politique Live", chaine: "Web TV", vues: 8500, likes: 1850, partages: 420 },
];

// ── 4. Interactions & Publicités ──────────────────────────────────
export const mockAdPerformance = [
  { id: "camp_01", titre: "Incitation Inscription Listes (ONG X)", impressions: 45000, clics: 1250, ctr: "2.8%", cout: "150 MAD" },
  { id: "camp_02", titre: "Webinaire Jeunesse et Politique", impressions: 32000, clics: 980, ctr: "3.1%", cout: "250 MAD" },
  { id: "camp_03", titre: "Meeting PI à Fès (Bannière)", impressions: 28000, clics: 650, ctr: "2.3%", cout: "400 MAD" },
  { id: "camp_04", titre: "Lancement Plateforme Plaidoyer", impressions: 15000, clics: 410, ctr: "2.7%", cout: "150 MAD" },
];

export const mockEventsPerformance = [
  { titre: "Débat Télévisé Régional (Casablanca)", vues: 5400, inscriptions: 850, partages: 320, likes: 1450 },
  { titre: "Permanence Citoyenne USFP", vues: 3200, inscriptions: 150, partages: 45, likes: 820 },
  { titre: "Atelier Observateurs Indépendants", vues: 2800, inscriptions: 420, partages: 180, likes: 930 },
  { titre: "Meeting d'Ouverture RNI", vues: 2100, inscriptions: 650, partages: 210, likes: 540 },
];

export const mockQuizEngagement = [
  { etape: "A commencé le Quiz", count: 285000 },
  { etape: "A dépassé 50% (Q10)", count: 242000 },
  { etape: "A terminé le Quiz (Resultat)", count: 218000 },
  { etape: "A partagé son résultat", count: 142000 },
];

// ── 5. Provenance Géographique ────────────────────────────────────
export const mockConnectionCountries = [
  { pays: "Maroc", visites: 14500, fill: "#10b981" },
  { pays: "France", visites: 1200, fill: "#3b82f6" },
  { pays: "Espagne", visites: 850, fill: "#f59e0b" },
  { pays: "Belgique", visites: 450, fill: "#8b5cf6" },
  { pays: "Autres", visites: 450, fill: "#64748b" },
];

export const mockConnectionCities = [
  { ville: "Casablanca", visites: 4800 },
  { ville: "Rabat", visites: 3200 },
  { ville: "Marrakech", visites: 1800 },
  { ville: "Tanger", visites: 1500 },
  { ville: "Agadir", visites: 900 },
];
